<template>
  <div>
    <h4 class="text-primary-dark">Siniestros</h4>
    <lista-siniestros :loading="loading" :siniestros="siniestros" :showCia="false" @siniestro-seleccionado="goToSiniestro($event)"/>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import ListaSiniestros from '@/components/widgets/siniestros/ListaSiniestros'
export default {
  data() { return {
    loading: true,
    sortKey: 'siniestro.fechaSiniestro',
    reverse: true,
    siniestros: []
    }
  },
  props: {
    idPoliza: {
      default: null
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      //siniestros: 'siniestros'
    })
  },
  mounted() {
    this.getSiniestros();
  },
  methods: {
    goToSiniestro(siniestro) {
      this.$router.push({ name: 'siniestro', params: { id: siniestro.id }});
    },
    getSiniestros() {
      this.loading = true;
      //this.$store.commit("clearSiniestros");
      let grupos = [
        'siniestro.poliza',
        'siniestro.riesgo',
        'siniestro.subestado',
        'poliza.producto',
        'poliza.compania',
        'poliza.riesgos',
        'poliza.cliente',
        'producto.ramo',
        'riesgoPoliza.riesgo'
      ]
      let params = {
        'idPoliza': this.idPoliza,
        'grupos': grupos.join(','),
        'limit': 100,
        'sort': 'siniestro.fechaSiniestro', 
        'inverse': 'true',
        'estado': '1,2'
      }
      //Recibos de póliza
      let url = this.urlBase + 'siniestros?' + util.objToQuery(params);
      this.$http.get(url).then(
        (response) => {
          this.siniestros = response.body.items;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      , this);
    }
  },
  components: {
    Loading,
    ListaSiniestros
  }
}
</script>
